import { Box } from '@material-ui/core';

import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { Font } from '@/components/shared/components/Font';
import { IconButton } from '@/components/shared/components/IconButton';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface MetricsListWrapperProps {
  page: number;
  rowsPerPage: number;
  totalElementsValue: number;
  onNext: () => void;
  onPrev: () => void;
  disableNext: boolean;
  disablePrev: boolean;
  children: React.ReactElement;
}

export const MetricsListWrapper = ({
  page,
  rowsPerPage,
  totalElementsValue,
  onNext,
  onPrev,
  disableNext,
  disablePrev,
  children,
}: MetricsListWrapperProps) => {
  const { palette } = useCustomTheme();
  const { getTextIdTranslation } = useTranslation();

  return (
    <CustomPaper
      fill="grey.light"
      style={{ padding: '16px 16px 38px 16px' }}
      boxProps={{ minHeight: '80px', maxHeight: '436px', maxWidth: '560px', position: 'relative' }}
    >
      <Box position={'relative'} height={'100%'} overflow={'auto'} padding={'2pxº'}>
        {children}
      </Box>
      <Box className={'channels-pagination'} px={1} style={{ paddingBottom: 10 }}>
        <Box mr={1}>
          <Font variant="caption" style={{ color: palette.grey[400] }}>
            {`${(page - 1) * rowsPerPage + 1}-${
              page * rowsPerPage > totalElementsValue ? totalElementsValue : page * rowsPerPage
            } ${getTextIdTranslation('OF')} ${totalElementsValue}`}
          </Font>
        </Box>
        <IconButton icon="chevron_left" size="small" onClick={onPrev} disabled={disablePrev} />
        <IconButton icon="chevron_right" size="small" onClick={onNext} disabled={disableNext} />
      </Box>
    </CustomPaper>
  );
};
